import "components/image_holder/square/image_holder_square.css";
import { AiFillPhone } from "react-icons/ai";
import { filterPizzaNouveaute } from "utils/filters/filterPizzaNouveaute.js";
import { CardTitle } from "../card_title.js";
import "./passer_commande.css";

export function CardTitlePasserCommande(props) {
  let pizzas = props.pizzas;
  let etablissement = props.etablissement;

  pizzas = filterPizzaNouveaute(pizzas);

  let imageContact = props.imageContact;

  let phone = etablissement.Telephone;

  return (
    <CardTitle className="card_title_passer_commande" title="Passer commande">
      <div className="phone">
        <AiFillPhone />
        <a href={"tel:" + phone.replace(/\s+/g, "")}>{phone}</a>
      </div>
      <div className="descritpion_holder">
        {imageContact !== undefined && (
          <div
            className={
              props.showOpening ? "image_holder_square" : "image_holder_xwide"
            }
          >
            <img src={imageContact} alt={props.alt}></img>
          </div>
        )}
        {props.showOpening && (
          <div className="opening">
            <div className="title_holder">
              <h1>Ouverture</h1>
            </div>
            <div className="opening_holder">
              <p>{etablissement.Ouverture}</p>
            </div>
          </div>
        )}
      </div>
    </CardTitle>
  );
}
